export default __webpack_public_path__ + "static/N0257-db5a8f52a5ec2fdb773582e272bf901c.png";